<!-- 放款逾期一覽表 -->
<template>
    <div class="row">
        <div class="col-12">
            <ListForm
                api="AssnUser"
                labelPosition="top"
                formTitle="放款逾期一覽表"
                :rules="rules"
                :recordToEdit="recordToEdit"
                :formType="formType"
            >
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="print">查詢</el-button>
                    <el-button type="primary" class="mb10" plain @click="print('pdf')">列印</el-button>

                    <!-- 查詢結果 -->
                    <el-table :data="tableData" v-if="showList" max-height="600" stripe border>
                        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
                        <el-table-column
                            v-for="(item,index) in columns"
                            :prop="item.prop"
                            :label="item.label"
                            :key="index"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <custom-row
                                    :scope="scope"
                                    :renderFunction="item.renderFunction"
                                    v-if="item.renderFunction"
                                ></custom-row>
                                <div v-else-if="item.addcomma">{{ $addcomma(scope.row[item.prop]) }}</div>
                                <div
                                    v-else-if="item.transferDate"
                                >{{ $transferDate(scope.row[item.prop]) }}</div>
                                <div v-else>{{ scope.row[item.prop] }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </ListForm>
            <div class="show-container">
                <div class="show"></div>
            </div>
        </div>
    </div>
</template>
<script>
import ListForm from "@/components/ListForm.vue";
import { API } from "@/assets/config";

export default {
    name: "loan_overdue",
    components: { ListForm },
    data() {
        return {
            columns: [
                {
                    prop: "account",
                    label: "帳號"
                },
                {
                    prop: "name",
                    label: "姓名"
                },
                {
                    prop: "iouNumber",
                    label: "借據號"
                },
                {
                    prop: "iouDate",
                    label: "貸款日期",
                    transferDate: true
                },
                {
                    prop: "iouAmount",
                    label: "貸款金額",
                    addcomma: true
                },
                {
                    prop: "normalAnnualRate",
                    label: "年利率%"
                },
                {
                    prop: "installmentMonths",
                    label: "期月數"
                },
                {
                    prop: "installmentAmount",
                    label: "期還金額",
                    addcomma: true
                },
                {
                    prop: "lastRepaymentDate",
                    label: "前還款日",
                    transferDate: true
                },
                {
                    prop: "noPayLoanAmount",
                    label: "欠付本金",
                    addcomma: true
                },
                {
                    prop: "lastInterestRepaymentDate",
                    label: "前繳息日",
                    transferDate: true
                },
                {
                    prop: "noPayInterestAmount",
                    label: "欠付利息",
                    addcomma: true
                },
                {
                    prop: "tel",
                    label: "連絡電話"
                },
                {
                    prop: "iouSurplus",
                    label: "貸款結餘",
                    addcomma: true
                },
                {
                    prop: "overDueMonth",
                    label: "逾月數"
                },
                {
                    prop: "stockSurplus",
                    label: "股金結餘",
                    addcomma: true
                }
            ],
            recordToEdit: {
                selectType: 0
            },
            formType: [
                {
                    label: "起訖條件選擇",
                    key: "selectType",
                    type: "radio",
                    options: [
                        {
                            label: "帳號",
                            value: 0
                        },
                        {
                            label: "群組",
                            value: 1
                        }
                    ]
                },
                {
                    label: "起訖帳號",
                    key: ["accountStart", "accountEnd"],
                    returnKey: "account",
                    type: "chooseMemberRange",
                    vif: true
                },
                {
                    label: "起訖群組",
                    key: ["groupCodeStart", "groupCodeEnd"],
                    type: "selectrange",
                    options: [],
                    vif: false,
                    filterable: true
                },
                {
                    type: "checkbox",
                    key: "isSortByOverDueMonth",
                    options: [{ label: "逾期月數排序" }]
                },
                {
                    label: "計算日期",
                    key: "balanceDate",
                    type: "date",
                    require: true
                }
            ],
            rules: {
                name: [
                    {
                        required: true,
                        message: "請輸入方案名稱",
                        trigger: "blur"
                    }
                ]
            },
            tableData: [],
            showList: false
        };
    },
    created() {
        this.getData();
    },
    watch: {
        recordToEdit: {
            handler(NewVal) {
                if (NewVal.selectType == 0) {
                    this.formType[1].vif = true;
                    this.formType[2].vif = false;
                } else {
                    this.formType[1].vif = false;
                    this.formType[2].vif = true;
                }
            },
            deep: true
        }
    },
    methods: {
        getData() {
            const url = API.memberGroup + `?action=getAll`;
            const thenCB = json => {
                this.formType[2].options = json.resultData.data.map(group => {
                    return { name: group.name, id: group.code };
                });
            };
            this.mAxiosGet(url, thenCB);
        },
        print(type) {
            try {
                this.check();
            } catch (error) {
                this.$message.error(error.message);
                return;
            }

            const vm = this;
            const url = API.CoopReport;
            let date =
                parseInt(
                    $(`.balanceDate`)
                        .val()
                        .split("-")[0]
                ) +
                1911 +
                $(`.balanceDate`)
                    .val()
                    .slice(3);

            let params = {
                action: "LoanOverdueList",
                balanceDate: date == "NaN" ? "" : date,
                isSortByOverDueMonth:
                    this.recordToEdit.isSortByOverDueMonth || 0
            };

            if (this.recordToEdit.selectType == 0) {
                // 帳號
                params.memberOption = 0;
                params.accountStart = this.recordToEdit.accountStart;
                params.accountEnd = this.recordToEdit.accountEnd;
            } else {
                // 群組
                params.memberOption = 1;
                params.accountStart = this.recordToEdit.groupCodeStart;
                params.accountEnd = this.recordToEdit.groupCodeEnd;
            }

            if (type == "pdf") {
                // pdf
                params.action = "LoanOverdueListPdf";

                this.mIframePDF(url, params);
            } else {
                // list
                this.showList = false;
                this.tableData = [];
                const thenCB = json => {
                    this.showList = true;
                    this.tableData = Object.assign(
                        [],
                        this.tableData,
                        json.resultData.data
                    );
                };
                this.mAxiosGet(url, thenCB, params, true);
            }
        },
        check() {
            if (!this.recordToEdit.balanceDate) {
                this.$message.closeAll();
                throw new Error("請選擇計算日期");
            }
        },
        removeIframe() {
            const removeEl = document
                .querySelector(".show-container iframe")
                .remove();
        }
    }
};
</script>